import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

const GetGlycerinArticleIdFragment = graphql(/* GraphQL */ `
  fragment GetGlycerinArticleIdFragment on Product {
    orderNumber
    promotion
  }
`);

export type GetGlycerinArticleIdProps = FragmentType<typeof GetGlycerinArticleIdFragment>;

export const getGlycerinArticleId = (data: GetGlycerinArticleIdProps) => {
  const { orderNumber, promotion } = getFragmentData(GetGlycerinArticleIdFragment, data);

  return { articleId: `${orderNumber}${promotion}` };
};
